import { CountryItem, countryData } from './phone-input.data';

// Allowed total digits count (country code included) of a phone number, one entry per country format
export const getCountryPhoneLengths = (country: CountryItem): number[] => {
  const lengths = country.format.map(
    (item) => item.split('').filter((curr) => curr === '#' || +curr).length + country.dialCode.length - 1,
  );

  return Array.from(new Set(lengths)).sort((a, b) => a - b);
};

const allCountriesLengths = countryData.flatMap(getCountryPhoneLengths);

export const PHONE_DIGITS_RANGE = {
  min: Math.min(...allCountriesLengths),
  max: Math.max(...allCountriesLengths),
};
